import InsightGraphs from './InsightGraphs'

export default InsightGraphs
